import { useCallback } from 'react'
import axios from 'axios'

const useRatingClient = () => {
  const sendFeedBack = useCallback((values) => axios.post('/tracksaleCampaign/answer', values), [])

  const getFeedBack = useCallback(() => axios.get('/tracksaleSchedule/today')
    .then((response) => response?.data), [])

  return useCallback(() => ({
    getFeedBack,
    sendFeedBack,
  }), [
    getFeedBack,
    sendFeedBack,
  ])
}

export default useRatingClient
